export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE"
export const UPDATE_FORM = "UPDATE_FORM"
export const UPDATE_FIELD = "UPDATE_FIELD"
export const UPDATE_SECTION = "UPDATE_SECTION"
export const HIDE_BUTTON = "HIDE_BUTTON"
export const UPDATE_CAPTCHA_STATUS = "UPDATE_CAPTCHA_STATUS"
export const SET_LOADER = "SET_LOADER"
export const REMOVE_ERROR = "REMOVE_ERROR"
export const CUSTOM_ERROR = "CUSTOM_ERROR"
export const UPDATE_SHOW_SECTION = "UPDATE_SHOW_SECTION"
export const DISABLE_SUBSCRIBE_BUTTON = "DISABLE_SUBSCRIBE_BUTTON"
